import { render } from "./Prism.vue?vue&type=template&id=166e4339"
import script from "./Prism.vue?vue&type=script&lang=js"
export * from "./Prism.vue?vue&type=script&lang=js"

import "./Prism.vue?vue&type=style&index=0&id=166e4339&lang=scss"
script.render = render

export default script